'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _contentPaste = require('../../icons/content-paste.svg');

var _contentPaste2 = _interopRequireDefault(_contentPaste);

var _check = require('../../icons/check.svg');

var _check2 = _interopRequireDefault(_check);

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CopyToClipboard = function (_React$Component) {
    _inherits(CopyToClipboard, _React$Component);

    function CopyToClipboard(props) {
        _classCallCheck(this, CopyToClipboard);

        var _this = _possibleConstructorReturn(this, (CopyToClipboard.__proto__ || Object.getPrototypeOf(CopyToClipboard)).call(this, props));

        _this.state = {
            copied: false
        };
        return _this;
    }

    _createClass(CopyToClipboard, [{
        key: 'copyToClipboard',
        value: function copyToClipboard() {
            var _this2 = this;

            this.textareaRef.select();
            document.execCommand('copy');
            this.setState({
                copied: true
            });
            setTimeout(function () {
                _this2.setState({
                    copied: false
                });
            }, 1500);
        }
    }, {
        key: 'renderCopiedText',
        value: function renderCopiedText() {
            if (this.state.copied) {
                return _react2.default.createElement(
                    'div',
                    { className: 'copied' },
                    'Copied to your clipboard!'
                );
            }
        }
    }, {
        key: 'renderTextArea',
        value: function renderTextArea() {
            var _this3 = this;

            return _react2.default.createElement('textarea', { ref: function ref(_ref) {
                    return _this3.textareaRef = _ref;
                },
                value: this.props.value,
                rows: this.props.visibleRows,
                readOnly: true });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            return _react2.default.createElement(
                'div',
                { className: 'copy-to-clipboard-component' },
                this.props.children ? _react2.default.createElement(
                    'div',
                    { className: 'custom-display' },
                    _react2.default.createElement(
                        'span',
                        {
                            className: 'child-container',
                            onClick: function onClick() {
                                return _this4.copyToClipboard();
                            } },
                        this.props.children
                    ),
                    this.renderCopiedText(),
                    _react2.default.createElement(
                        'div',
                        { className: 'hidden-text-area' },
                        this.renderTextArea()
                    )
                ) : _react2.default.createElement(
                    'div',
                    { className: 'default-display' },
                    _react2.default.createElement(
                        'div',
                        { className: 'copy-value' },
                        this.renderCopiedText(),
                        this.renderTextArea()
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { className: 'copy-button',
                            onClick: function onClick() {
                                return _this4.copyToClipboard();
                            },
                            'aria-live': this.state.copied ? 'polite' : 'off',
                            'aria-label': this.state.copied ? 'copied to your clipboard' : 'copy to clipboard' },
                        _react2.default.createElement('span', { className: 'center-shift' }),
                        this.state.copied ? this.props.postCopyIcon : this.props.preCopyIcon
                    )
                )
            );
        }
    }]);

    return CopyToClipboard;
}(_react2.default.Component);

CopyToClipboard.defaultProps = {
    visibleRows: 2,
    preCopyIcon: _react2.default.createElement(_Icon2.default, { def: _contentPaste2.default }),
    postCopyIcon: _react2.default.createElement(_Icon2.default, { def: _check2.default })
};

CopyToClipboard.propTypes = {
    value: _propTypes2.default.string.isRequired,
    visibleRows: _propTypes2.default.number,
    children: _propTypes2.default.node,
    preCopyIcon: _propTypes2.default.any.isRequired,
    postCopyIcon: _propTypes2.default.any.isRequired
};

exports.default = CopyToClipboard;
//# sourceMappingURL=index.js.map